import { render, staticRenderFns } from "./RequestedInventoryItem.vue?vue&type=template&id=eb996b16&scoped=true&"
import script from "./RequestedInventoryItem.vue?vue&type=script&lang=js&"
export * from "./RequestedInventoryItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestedInventoryItem.vue?vue&type=style&index=0&id=eb996b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb996b16",
  null
  
)

export default component.exports